import PropTypes from "prop-types";
import { IconButton, SvgIcon, Tooltip, useTheme } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookmark as regularBookmark } from "@fortawesome/pro-regular-svg-icons";
import { faBookmark as solidBookmark } from "@fortawesome/pro-solid-svg-icons";
import useBookmarkToggle from "./use-bookmark-toggle";

export const BookmarkIconButton = ({ enabled, itemType, itemId, assetPath }) => {
  const theme = useTheme();
  const { checked, updating, handleToggle, label } = useBookmarkToggle({
    enabled,
    itemType,
    itemId,
    assetPath,
  });

  return (
    <Tooltip title={label}>
      <span>
        <IconButton
          data-testid="bookmark-toggle"
          aria-label={label}
          aria-pressed={checked}
          onClick={handleToggle}
          disabled={updating}
          sx={{ width: 40, height: 40 }}
        >
          <SvgIcon sx={{ fontSize: 18, color: theme.palette.brandText }}>
            <FontAwesomeIcon
              icon={checked ? solidBookmark : regularBookmark}
            />
          </SvgIcon>
        </IconButton>
      </span>
    </Tooltip>
  );
};

BookmarkIconButton.propTypes = {
  enabled: PropTypes.bool.isRequired,
  itemType: PropTypes.oneOf([
    "documents",
    "images",
    "videos",
    "audios",
    "news",
    "assets",
  ]).isRequired,
  itemId: PropTypes.number.isRequired,
  assetPath: PropTypes.string,
};
